const skuToIgnoreCOD = [
  "49842150867250",
  "49842150900018",
  "49842150932786",
  "49842150965554",
  "49842150998322",
  "49842151031090",
  "49842151063858",
  "49842151096626",
  "49842151129394",
  "49842151162162",
  "50017758871858",
  "50017758904626",
  "50017758937394",
  "50017758970162",
  "50017759002930",
  "50007821451570",
  "50007821484338",
  "50007821517106",
  "50007821549874",
  "50007821582642",
  "50004483211570",
  "50007834034482",
  "50007834067250",
  "50007834100018",
  "50007834100018",
  "50007833805106",
  "50007834165554",
  "50007834198322",
  "50007834231090",
  "50007834263858",
  "49993599287602",
  "49993599320370",
  "49993599353138",
  "49993599385906",
  "49993599418674",
  "49989082186034",
  "49989082218802",
  "49989082251570",
  "49989082251570",
  "49989082317106",
  "49989021073714",
  "49989021106482",
  "49989021139250",
  "49989021172018",
  "49989021204786",
  "49990286967090",
  "49990286999858",
  "49990287032626",
  "49990287065394",
  "49990287098162",
  "49990287130930",
  "49990287163698",
  "49990287196466",
  "49990287229234",
  "49990287262002",
  "49990287294770",
  "49990287327538",
  "49990287360306",
  "49990287393074",
  "49990287425842",
  "49978138788146",
  "49978138820914",
  "49978138853682",
  "49978138886450",
  "49978120175922",
  "49978120208690",
  "49978120241458",
  "49978120274226",
  "49978120306994",
  "49978120339762",
  "49978120372530",
  "49978120405298",
  "49978120438066",
  "49978120470834",
  "49978120503602",
  "49978120536370",
  "49978120569138",
  "49978120601906",
  "49978120634674",
  "49842382995762",
  "49842383028530",
  "49842383061298",
  "49842383094066",
  "49842383126834",
  "49842367627570",
  "49842367660338",
  "49842367693106",
  "49842367725874",
  "49842367758642",
  "49842348851506",
  "49842348884274",
  "49842348917042",
  "49842348949810",
  "49842348982578",
  "49842117050674",
  "49842117083442",
  "49842117116210",
  "49842117148978",
  "49842117181746",
  "49842117214514",
  "49842117247282",
  "49842117280050",
  "49842117312818",
  "49842117345586",
  "49931707875634",
  "49931707908402",
  "49931707941170",
  "49931707973938",
  "49931708006706",
  "49931708039474",
  "49931708072242",
  "49931708105010",
  "49931708137778",
  "49931708170546",
  "49713781178674",
  "49713781211442",
  "49713781244210",
  "49713817944370",
  "49713817977138",
  "50066009588018",
  "50066009620786",
  "50066009653554",
  "50066009686322",
  "50066009719090",
  "50065895031090",
  "50065926684978",
  "50065926717746",
  "50065926750514",
  "50065926783282",
  "50065926816050",
  "50065926848818",
  "50065926881586",
  "50065926914354",
  "50065926947122",
  "50072960467250",
  "50072960500018",
  "50072960532786",
  "50072960565554",
  "50072960598322",
  "50072784437554",
  "50072784470322",
  "50072784503090",
  "50072784535858",
  "50072784568626",
  "50072948441394",
  "50072948474162",
  "50072948506930",
  "50072948539698",
  "50072948572466",
  "50066000281906",
  "50066000314674",
  "50066000347442",
  "50066000380210",
  "50066000412978",
  "50066000445746",
  "50066000478514",
  "50066000511282",
  "50066000544050",
  "50066000576818",
  "50066057658674",
  "50066057691442",
  "50066057724210",
  "50066057756978",
  "50066057789746",
  "50066057822514",
  "50066057855282",
  "50066057888050",
  "50066057920818",
  "50066057953586",
  "50072867930418",
  "50072867963186",
  "50072867995954",
  "50072868028722",
  "50072868061490",
  "50074362839346",
  "50074362872114",
  "50074362904882",
  "50074362937650",
  "50074362970418",
  "50074073235762",
  "50074073268530",
  "50074073301298",
  "50074073334066",
  "50074073366834",
  "50083576643890",
  "50083576676658",
  "50083576709426",
  "50083576742194",
  "50083576774962",
  "50083522052402",
  "50083522085170",
  "50083522117938",
  "50083522150706",
  "50083522183474",
  "50086969803058",
  "50086969835826",
  "50086969868594",
  "50086969901362",
  "50086969934130",
  "50086969966898",
  "50086969999666",
  "50086970032434",
  "50086970065202",
  "50086970097970",
  "50083545317682",
  "50083545350450",
  "50083545383218",
  "50083545415986",
  "50083545448754",
  "50083545481522",
  "50083545514290",
  "50083545547058",
  "50083545579826",
  "50083545612594",
  "50086987137330",
  "50086987170098",
  "50086987202866",
  "50086987235634",
  "50086987268402",
  "50116245356850",
  "50116245389618",
  "50116245422386",
  "50116245455154",
  "50116245487922",
  "50116245520690",
  "50116245553458",
  "50116245586226",
  "50116245618994",
  "50116245651762",
  "50116245684530",
  "50116245717298",
  "50116245750066",
  "50116245782834",
  "50116245815602",
  "50116055793970",
  "50119821492530",
  "50119821525298",
  "50119821558066",
  "50119821590834",
  "50116055826738",
  "50119821623602",
  "50119821656370",
  "50119821689138",
  "50119821721906",
  "50116085514546",
  "50119840923954",
  "50119840956722",
  "50119840989490",
  "50119841022258",
  "50116161634610",
  "50116161667378",
  "50116161700146",
  "50116161732914",
  "50116161765682",
  "50116161798450",
  "50116161831218",
  "50116161863986",
  "50116161896754",
  "50116161929522",
  "50116161962290",
  "50116161995058",
  "50116162027826",
  "50116162060594",
  "50116162093362",
  "50116219404594",
  "50116219437362",
  "50116219470130",
  "50116219470130",
  "50116219502898",
  "50116219568434",
  "50116219601202",
  "50116219633970",
  "50116219666738",
  "50116219699506",
  "50119714111794",
  "50119714144562",
  "50119714177330",
  "50119714210098",
  "50119714242866",
  "50482435752242",
  "50482435785010",
  "50482435817778",
  "50482435850546",
  "50482435883314",
  "50617571213618",
  "50617571246386",
  "50617571279154",
  "50617571311922",
  "50620887073074",
  "50552022499634",
  "50552022532402",
  "50552022565170",
  "50552022597938",
  "50552022630706",
  "50552068440370",
  "50552068473138",
  "50552068505906",
  "50552068538674",
  "50552068571442",

  "50669758120242",
  "50669758153010",
  "50669758185778",
  "50669758218546",
  "50669758251314", 
  "50669758284082",
  "50669758316850",
  "50669758349618",
  "50669758382386",
  "50669758415154",
  "50669758447922",
  "50669758480690",
  "50669758513458",
  "50669758546226",
  "50669758578994",
  "50669758611762",
  "50669758644530",
  "50669758677298",
  "50669758710066",
  "50669758742834",
  "50641053614386",
  "50641053647154",
  "50641053679922", 
  "50641053712690",
  "50641053745458",
  "50641053778226",
  "50641053810994",
  "50641053843762",
  "50641053876530",
  "50641053909298",
  "50641053942066",
  "50641053974834",
  "50641054007602",
  "50641054040370",
  "50641054073138",
  "50641054105906",
  "50641054138674",
  "50641054171442",
  "50641054204210",
  "50641054236978",
  "50624444825906",
  "50624444858674",
  "50624444891442",
  "50624444924210",
  "50624444956978",
  "50624444989746",
  "50624445022514",
  "50624445055282",
  "50624445088050",
  "50624445120818",
  "50624424575282",
  "50624424608050",
  "50624424640818",
  "50624424673586",
  "50624424706354",
  "50624424739122",
  "50624424771890",
  "50624424804658",
  "50624424837426",
  "50624424870194",
  "50624411697458",
  "50624411730226",
  "50624411762994",
  "50624411795762",
  "50624411828530",
  "50625629585714",
  "50617724109106",
  "50617724141874",
  "50617724174642",
  "50617724207410",
  "50624793084210",
  "50625629618482",
  "50617724240178",
  "50617724272946",
  "50617724305714",
  "50617724338482",
  "50624793116978",
  "50617705365810",
  "50617705398578",
  "50617705431346",
  "50617705464114",
  "50617705496882",
  "50617705529650",
  "50617705562418",
  "50617705595186",
  "50617705627954",
  "50617705660722",
  "50617683640626",
  "50617683673394",
  "50617683738930",
  "50617683771698",
  "50617683804466",
  "50617683837234",
  "50617683870002",
  "50617683902770",
  "50617683935538",
  "50617571213618",
  "50617571246386",
  "50617571279154",
  "50617571311922",
  "50620887073074",
  "50617519145266",
  "50617519178034",
  "50617519210802",
  "50617519243570",
  "50617519276338",
  "50552041636146",
  "50552041668914",
  "50552041701682",
  "50552041734450",
  "50552041767218",
  "50617552601394",
  "50617552634162",
  "50617552666930",
  "50617552699698",
  "50617552732466",
  "50617552798002",
  "50617552830770",
  "50617552863538",
  "50617552896306",
  "50617552929074",
  "50617552994610",
  "50617553027378",
  "50617553060146",
  "50617553092914",
  "50617553125682",
  "50617553191218",
  "50617553223986",
  "50617553256754",
  "50617553289522",
  "50617553322290",
  "50552640110898",
  "50552640143666",
  "50552640176434",
  "50552640209202",
  "50552640241970",
  "50552640307506",
  "50552640340274",
  "50552640373042",
  "50552640405810",
  "50552640438578",
  "50552034591026",
  "50552034623794",
  "50552034656562",
  "50552034689330",
  "50552034558258",
  "49643676533042",
  "49643676565810",
  "49643676598578",
  "49643676631346",
  "49643676664114",
  "50066000281906",
  "50066000314674",
  "50066000347442",
  "50066000380210",
  "50066000412978",
  "50066000445746",
  "50066000478514",
  "50066000511282",
  "50066000544050",
  "50066000576818",
  "50408388395314",
  "50408388428082",
  "50408388460850",
  "50408388493618",
  "50408388526386",
  "50408388559154",
  "50408388591922",
  "50408388624690",
  "50408388657458",
  "50408388690226",
  "50441896788274",
  "50441896821042",
  "50441896853810",
  "50441896886578",
  "50441896919346",
  "50441982640434",
  "50441982673202",
  "50441982705970",
  "50441982738738",
  "50441982771506",
  "50455402348850",
  "50455402381618",
  "50455402414386",
  "50455402447154",
  "50455402479922",
  "50455402512690",
  "50455402545458",
  "50455402578226",
  "50455402610994",
  "50455402643762",
  "50456434966834",
  "50456434999602",
  "50456435032370",
  "50456435065138",
  "50456435097906",
  "50456435130674",
  "50456435163442",
  "50456435196210",
  "50456435228978",
  "50456435261746",
  "50456437457202",
  "50456437489970",
  "50456437522738",
  "50456437555506",
  "50456437588274",
  "50482377556274",
  "50482377589042",
  "50482377621810",
  "50482377654578",
  "50482377687346",
  "50482377720114",
  "50482377752882",
  "50482377785650",
  "50482377818418",
  "50482377851186",
  "50482390139186",
  "50482390171954",
  "50482390204722",
  "50482390237490",
  "50482390270258",
  "50482490016050",
  "50482490048818",
  "50482490081586",
  "50482490114354",
  "50482490147122",
  "50482489852210",
  "50482489884978",
  "50482489917746",
  "50482489950514",
  "50482489983282",
  "50482579112242",
  "50482579145010",
  "50482579177778",
  "50482579210546",
  "50482579243314",
  "50482578948402",
  "50482578981170",
  "50482579013938",
  "50482579046706",
  "50482579079474",
  "50482579276082",
  "50482579308850",
  "50482579341618",
  "50482579374386",
  "50482579407154",
  "50552006770994",
  "50552006803762",
  "50552006836530",
  "50552006869298",
  "50552006902066",
  "50552006934834",
  "50552006967602",
  "50552007000370",
  "50552007033138",
  "50552007065906",
  "50552007098674",
  "50552007131442",
  "50552007164210",
  "50552007196978",
  "50552007229746",
  "50552007262514",
  "50552007295282",
  "50552007328050",
  "50552007360818",
  "50552007393586",
  "50810266255666",
  "50810266288434",
  "50810266321202",
  "50810266353970",
  "50810266386738",
  "50810266419506",
  "50810266452274",
  "50810266485042",
  "50810266517810",
  "50810266550578",
  "50810266583346",
  "50810266616114",
  "50810266648882",
  "50810266681650",
  "50810266714418",
  "50810266747186",
  "50810266779954",
  "50810266812722",
  "50810266845490",
  "50810266878258",
  "50810318618930",
  "50810318651698",
  "50810318684466",
  "50810318717234",
  "50810318750002",
  "50810293616946",
  "50810293715250",
  "50810293813554",
  "50810293911858",
  "50810294010162",
  "50810293649714",
  "50810293748018",
  "50810293846322",
  "50810293944626",
  "50810294042930",
  "50810293682482",
  "50810293780786",
  "50810293879090",
  "50810293977394",
  "50810294075698",
  "50810326057266",
  "50810326090034",
  "50810326122802",
  "50810326155570",
  "50810326188338",
  "50810305216818",
  "50810305249586",
  "50810305282354",
  "50810305315122",
  "50810305347890",
  "50810305380658",
  "50810305413426",
  "50810305446194",
  "50810305478962",
  "50810305511730",
  "50810305544498",
  "50810305577266",
  "50810305610034",
  "50810305642802",
  "50810305675570",
  "50858050355506",
  "50858050388274",
  "50858050421042",
  "50858050453810",
  "50858050486578",
  "50858062872882",
  "50858062905650",
  "50858062938418",
  "50858062971186",
  "50858063003954",
  "50859209392434",
  "50859209425202",
  "50859209457970",
  "50859209490738",
  "50859209523506",
  "50859261198642",
  "50859261231410",
  "50859261264178",
  "50859261296946",
  "50859261329714",
  "50859626299698",
  "50859626332466",
  "50859626365234",
  "50859626398002",
  "50859626430770",
  "50862036386098",
  "50862036418866",
  "50862036451634",
  "50862036484402",
  "50862036517170",
  "50862036549938",
  "50862036582706",
  "50862036615474",
  "50862036648242",
  "50862036681010",
  "50862036713778",
  "50862036746546",
  "50862036779314",
  "50862036812082",
  "50862036844850",
  "50862073119026",
  "50862073151794",
  "50862073184562",
  "50862073217330",
  "50862073250098",
  "50862073282866",
  "50862073315634",
  "50862073348402",
  "50862073381170",
  "50862073413938",
  "50862073446706",
  "50862073479474",
  "50862073512242",
  "50862073545010",
  "50862073577778",
  "50862085570866",
  "50862085603634",
  "50862085636402",
  "50862085669170",
  "50862085701938",
  "50862085734706",
  "50862085767474",
  "50862085800242",
  "50862085833010",
  "50862085865778",
  "50862085898546",
  "50862085931314",
  "50862085964082",
  "50862085996850",
  "50862086029618",
  "50862134329650",
  "50862134362418",
  "50862134395186",
  "50862134427954",
  "50862134460722",
  "50862134493490",
  "50862134526258",
  "50862134559026",
  "50862134591794",
  "50862134624562",
  "50862134657330",
  "50862134690098",
  "50862134722866",
  "50862134755634",
  "50862134788402",
  "50862175387954",
  "50862175420722",
  "50862175453490",
  "50862175486258",
  "50862175519026",
  "50862175551794",
  "50862175584562",
  "50862175617330",
  "50862175650098",
  "50862175682866",
  "50862175715634",
  "50862175748402",
  "50862175781170",
  "50862175813938",
  "50862175846706",
];
const skuToAppendCOD = [];

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      } else {
        appendCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};
